/* eslint-disable react/jsx-props-no-spreading */
// CheckoutForm.js
import React from 'react';
import { Button, Col, Row, Alert } from 'react-bootstrap';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement,
  injectStripe,
  PaymentRequestButtonElement,
} from 'react-stripe-elements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import Loading from '../loading';
import DisplayCheckboxesOrNot from '../terms-and-signUp-checkboxes';

import './style.css';
import Content from '../../constants/Content';
import GTM from '../../services/GTM';

class InjectedPaymentForm extends React.Component {
  constructor(props) {
    super(props);

    let paymentRequestObject;
    if (props.isCheckout) {
      paymentRequestObject = this.constructPaymentRequestObject(props);
    }

    this.state = {
      paymentRequestButton: false,
      showCreditCardForm: false,
      paymentRequest: null,
      paymentRequestObject,
      cardNumberEmpty: true,
      cardCvcEmpty: true,
      cardExpiryEmpty: true,
      postalCodeEmpty: true,
    };
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.isCheckout) {
      const paymentRequestObject = this.constructPaymentRequestObject(
        nextProps,
      );
      this.setState({ paymentRequestObject });
    }
  };

  constructPaymentRequestObject = (props) => {
    const displayItems = [
      {
        label: 'Subtotal',
        amount: parseInt(props.totals.subTotal.replace(/\./g, ''), 10),
      },
      {
        label: 'Shipping',
        amount: parseInt(props.totals.shipping.replace(/\./g, ''), 10),
      },
      {
        label: 'Taxes and Fees',
        amount: parseInt(props.totals.taxesAndFees.replace(/\./g, ''), 10),
      },
    ];
    if (props.totals.pointsDiscount !== '0.00') {
      displayItems.push({
        label: 'Points',
        amount: -Math.abs(
          parseInt(props.totals.pointsDiscount.replace(/\./g, ''), 10),
        ),
      });
    }
    if (props.totals.giftCardDiscount !== '0.00') {
      displayItems.push({
        label: 'Gift Card',
        amount: -Math.abs(
          parseInt(props.totals.giftCardDiscount.replace(/\./g, ''), 10),
        ),
      });
    }
    if (props.totals.couponDiscount !== '0.00') {
      displayItems.push({
        label: 'Discount',
        amount: -Math.abs(
          parseInt(props.totals.couponDiscount.replace(/\./g, ''), 10),
        ),
      });
    }
    const paymentRequestObject = {
      total: {
        label: Content.names.fancyNamePlural,
        amount: parseInt(props.totals.total.replace(/\./g, ''), 10),
      },
      displayItems,
    };
    return paymentRequestObject;
  };

  handleBlur = (e) => {
    this.setState({ [e.elementType]: false });
    if (!this.state.cardNumberEmpty) this.setState({ cardNumber: true });
    if (!this.state.cardCvcEmpty) this.setState({ cardCvc: true });
    if (!this.state.cardExpiryEmpty) this.setState({ cardExpiry: true });
    if (!this.state.postalCodeEmpty) this.setState({ postalCode: true });
  };

  handleFocus = (e) => {
    this.setState({ [e.elementType]: true });
  };

  handleReady = (e) => {
    this.setState({ [e.elementType]: true });
  };

  handleOnChange = (e) => {
    this.props.onChange(e);
    const typeIsEmpty = `${e.elementType}Empty`;
    if (e.empty) {
      this.setState({ [e.elementType]: false, [typeIsEmpty]: true });
    } else {
      this.setState({ [e.elementType]: true, [typeIsEmpty]: false });
    }
  };

  createStripePaymentRequest = () => {
    const { paymentRequestObject } = this.state;
    paymentRequestObject.country = 'US';
    paymentRequestObject.currency = 'usd';
    const stripePaymentRequest = this.props.stripe.paymentRequest(
      paymentRequestObject,
    );

    // eslint-disable-next-line no-unused-vars
    stripePaymentRequest.on('token', ({ complete, token, ...data }) => {
      this.props.goToNextStep('ignore', this.props, token);
      complete('success');
    });

    stripePaymentRequest.canMakePayment().then((result) => {
      GTM.paymentRequestStatus(result);
      if (result) {
        this.setState({
          paymentRequestButton: !!result,
          paymentRequest: stripePaymentRequest,
        });
      }
    });
  };

  createOptions = () => ({
    style: {
      base: {
        fontSize: '14px',
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: '"Open Sans", Helvetica, sans-serif',
        '::placeholder': {
          color: 'black',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  });

  CreditCardForm = () => {
    const showPaymentRequestButton = () => {
      this.setState({ showCreditCardForm: false });
    };

    return (
      <form className='credit-card-form-component cardDetails'>
        <Row className='show-grid'>
          <Col md={12} lg={12} className='creditCard-Col'>
            <span className={this.state.cardNumber ? 'cardNumber' : ''}>
              {' '}
              Card number{' '}
            </span>
            <CardNumberElement
              className='checkoutCardNumber stripeInput form-control'
              placeholder=''
              onBlur={this.handleBlur}
              onChange={(e) => this.handleOnChange(e)}
              onFocus={this.handleFocus}
              onReady={this.handleReady}
              {...this.createOptions()}
            />
          </Col>
          <Col md={4} lg={4} className='creditCard-Col'>
            <span className={this.state.cardExpiry ? 'cardExpiry' : ''}>
              {' '}
              Exp. Date{' '}
            </span>
            <CardExpiryElement
              className='checkoutExpirationDate stripeInput form-control'
              placeholder=''
              onBlur={this.handleBlur}
              onChange={(e) => this.handleOnChange(e)}
              onFocus={this.handleFocus}
              onReady={this.handleReady}
              {...this.createOptions()}
            />
          </Col>
          <Col md={4} lg={4} className='creditCard-Col'>
            <span className={this.state.cardCvc ? 'cardCvc' : ''}> CVC </span>
            <CardCVCElement
              className='checkoutCvc stripeInput form-control'
              placeholder=''
              onBlur={this.handleBlur}
              onChange={(e) => this.handleOnChange(e)}
              onFocus={this.handleFocus}
              onReady={this.handleReady}
              {...this.createOptions()}
            />
          </Col>
          <Col md={4} lg={4} className='creditCard-Col'>
            <span className={this.state.postalCode ? 'postalCode' : ''}>
              {' '}
              Zip Code{' '}
            </span>
            <PostalCodeElement
              className='checkoutPostalCode stripeInput form-control'
              placeholder=''
              onBlur={this.handleBlur}
              onChange={(e) => this.handleOnChange(e)}
              onFocus={this.handleFocus}
              onReady={this.handleReady}
              {...this.createOptions()}
            />
          </Col>
        </Row>

        <div className='paddingSm' />

        {this.props.error ? (
          <div className='form-error'>
            <Alert variant='danger'>{this.props.error}</Alert>
          </div>
        ) : null}
        <DisplayCheckboxesOrNot
          toggleSubscriptionToNewsletter={
            this.props.toggleSubscriptionToNewsletter
          }
          toggleTermsAndConditions={this.props.toggleTermsAndConditions}
          termsAndConditionsError={this.props.termsAndConditionsError}
          isHideDisplayCheckboxes={this.props.isHideDisplayCheckboxes}
          formValuesValidationState={this.props.formValuesValidationState}
          hasBeenSubmitted={this.props.hasBeenSubmitted}
          formValues={this.props.formValues}
          handleChange={this.props.handleChange}
        />
        <div className='paddingSm' />
        {this.props.isEdit ? (
          <Row className='show-grid'>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Button
                className='creditCardSubmitBtn'
                disabled={this.props.hasBeenSubmitted}
                variant='primary'
                onClick={(ev) => this.props.goToNextStep(ev, this.props)}
              >
                {this.props.isLoading ? <Loading /> : <div>SUBMIT</div>}
              </Button>
            </Col>
          </Row>
        ) : (
          <Col md={12} lg={12}>
            {this.props.unknownError ? (
              <Col className='form-error'>
                <Alert variant='danger'>{this.props.unknownError}</Alert>
              </Col>
            ) : null}
            <Button
              className='place-order place-credit-card-order'
              disabled={this.props.hasBeenSubmitted}
              onClick={(ev) => this.props.goToNextStep(ev, this.props)}
            >
              {this.props.isLoading ? (
                <Loading />
              ) : (
                <>
                  <FontAwesomeIcon icon={faLock} />
                  {`PAY${
                    this.props.totals && this.props.totals.total
                      ? ` $${this.props.totals.total}`
                      : ''
                  }`}
                </>
              )}
            </Button>
          </Col>
        )}
        {this.state.paymentRequestButton ? (
          <Button
            className='creditCardButton'
            onClick={showPaymentRequestButton}
          >
            Use your saved payment info instead
          </Button>
        ) : null}
      </form>
    );
  };

  PaymentRequestForm = () => {
    const showCreditCardForm = () => {
      this.setState({ showCreditCardForm: true });
    };

    const updatePaymentRequest = (event) => {
      if (!this.state.paymentRequestObject) {
        event.preventDefault();
        return;
      }
      const stripePaymentRequest = this.state.paymentRequest;
      stripePaymentRequest.update(this.state.paymentRequestObject);
      this.setState((prevState) => ({
        ...prevState,
        paymentRequest: stripePaymentRequest,
      }));
    };

    return (
      <div className='payment-request-component'>
        {this.props.isGuestCheckout ? (
          <DisplayCheckboxesOrNot
            toggleSubscriptionToNewsletter={
              this.props.toggleSubscriptionToNewsletter
            }
            toggleTermsAndConditions={this.props.toggleTermsAndConditions}
            isHideDisplayCheckboxes={this.props.isHideDisplayCheckboxes}
            formValuesValidationState={this.props.formValuesValidationState}
            hasBeenSubmitted={this.props.hasBeenSubmitted}
            formValues={this.props.formValues}
            handleChange={this.props.handleChange}
            termsAndConditionsError={this.props.termsAndConditionsError}
          />
        ) : null}
        <h4>Pay Now</h4>

        <PaymentRequestButtonElement
          paymentRequest={this.state.paymentRequest}
          onClick={updatePaymentRequest}
          className='PaymentRequestButton'
        />
        <div>
          <Button className='creditCardButton' onClick={showCreditCardForm}>
            Enter your credit card info instead
          </Button>
        </div>
      </div>
    );
  };

  render() {
    if (
      this.props.stripe &&
      !this.state.paymentRequest &&
      this.props.isCheckout
    ) {
      this.createStripePaymentRequest();
    }

    if (
      this.state.paymentRequestButton &&
      !this.state.showCreditCardForm &&
      this.props.isCheckout
    ) {
      return <div>{this.PaymentRequestForm()}</div>;
    }
    return <div>{this.CreditCardForm()}</div>;
  }
}

export default injectStripe(InjectedPaymentForm);
